<template>
  <div id="unauthorized">
    <div class="sectionheader">
      <h1>401</h1>
      <p>Unauthorized!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Unauthorized",
};
</script>

<style scoped>
.sectionheader {
  text-align: center;
}
</style>
